export const getSupervisionId = supervision => supervision.id
